<script>
import Router from "svelte-spa-router";
import Index from "./routes/Index.svelte";
import Home from "./routes/Home.svelte";
import ProductList from "./routes/ProductList.svelte";
import ProductItem from "./routes/ProductItem.svelte";
import Theme from "./routes/Theme.svelte";
import Contact from "./routes/Contact.svelte";
import Faq from "./routes/Faq.svelte";
import HomeSignedIn from "./routes/HomeSignedIn.svelte";
import DeliveryNotice from "./routes/DeliveryNotice.svelte";
import CreateAccount from "./routes/CreateAccount.svelte";
import AccountCreated from "./routes/AccountCreated.svelte";
import ForgotPass from "./routes/ForgotPass.svelte";
import InfoSent from "./routes/InfoSent.svelte";
import CompanyCreated from "./routes/CompanyCreated.svelte";
import ComplaintOne from "./routes/ComplaintOne.svelte";
import ComplaintThree from "./routes/ComplaintThree.svelte";
import ComplaintFour from "./routes/ComplaintFour.svelte";
import ComplaintFive from "./routes/ComplaintFive.svelte";
import ComplaintSix from "./routes/ComplaintSix.svelte";
import ComplaintTwo from "./routes/ComplaintTwo.svelte";
import ComplaintStart from "./routes/ComplaintStart.svelte";
import ComplaintFourMan from "./routes/ComplaintFourMan.svelte";
import CreateCoAccount from "./routes/CreateCoAccount.svelte";
import LoginPage from "./routes/LoginPage.svelte";
import Partners from "./routes/Partners.svelte";
import Checkout1 from "./routes/gtm/Checkout1.svelte";
import Checkout2 from "./routes/gtm/Checkout2.svelte";
import Checkout3 from "./routes/gtm/Checkout3.svelte";
import Purchase from "./routes/gtm/Purchase.svelte";
import Refactoring from "./routes/gtm/Refactoring.svelte";

const routes = {
  // Exact path
  "/": Index,
  "/home": Home,
  "/home-signed-in": HomeSignedIn,
  "/list": ProductList,
  "/items": ProductItem,
  "/theme": Theme,
  "/contact": Contact,
  "/faq": Faq,
  "/delivery-notice": DeliveryNotice,
  "/create-account": CreateAccount,
  "/account-created": AccountCreated,
  "/forgot-password": ForgotPass,
  "/information-sent": InfoSent,
  "/company-account-created": CompanyCreated,
  "/complaint-step-one": ComplaintOne,
  "/complaint-step-three": ComplaintThree,
  "/complaint-step-four": ComplaintFour,
  "/complaint-step-five": ComplaintFive,
  "/complaint-step-six": ComplaintSix,
  "/complaint-step-two": ComplaintTwo,
  "/complaint-start": ComplaintStart,
  "/complaint-step-four-man": ComplaintFourMan,
  "/create-co-account": CreateCoAccount,
  "/login-page": LoginPage,
  "/partners": Partners,
  "/gtm/checkout1": Checkout1,
  "/gtm/checkout2": Checkout2,
  "/gtm/checkout3": Checkout3,
  "/gtm/purchase": Purchase,
  "/gtm/refactoring": Refactoring,
};
</script>

<Router routes="{routes}" />
